import { render, staticRenderFns } from "./customNumberField.vue?vue&type=template&id=91bcda76&scoped=true&"
import script from "./customNumberField.vue?vue&type=script&lang=js&"
export * from "./customNumberField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bcda76",
  null
  
)

export default component.exports